import cx from 'classnames';

import { defaultInputClassConfigs } from './constants';

interface GetInputBorderAndPaddingArgs {
    classConfig?: InputClassConfig;
    hasFocus: boolean;
    padding: InputPadding;
}

export const getInputBorderAndPadding = (
    args: GetInputBorderAndPaddingArgs,
): string => {
    const { padding } = args;
    const classConfig = args.classConfig ?? defaultInputClassConfigs[padding];

    return cx(classConfig.base, {
        [classConfig.focus]: args.hasFocus,
        [classConfig.blur]: !args.hasFocus,
    });
};
